import { WIDGET_HIDE, WIDGET_CLOSE, SET_WIDGET_VIEW } from 'common/widgetConstants';
import widgetDesign from './widget-design';
import { isMobileView as isFullScreen } from './responsive';
import { createElement, Div } from './utils';

const { defaultStyle } = widgetDesign;
const fullSpace = { height: '100%', width: '100%' };

const buildFrame = ({
  webchatBaseUrl,
  data,
  onHide,
  onClose,
  params = [],
  afterLoadAnimation = () => {},
  settings: {
    screenReaderLabels: { regionTitle },
  },
}) => {
  const style = Object.assign({}, defaultStyle, fullSpace);

  let iframeSrc = `${webchatBaseUrl}/chat/${data.entrypointToken}`;

  if (params.length) iframeSrc += `?${params.join('&')}`;

  const iframe = createElement(
    'iframe',
    Object.assign(
      {
        id: 'webchat',
        frameBorder: false,
        scrolling: 'no',
        src: iframeSrc,
        style,
        title: regionTitle,
        allow: 'geolocation; microphone; autoplay',
      },
      fullSpace
    )
  );

  iframe.addEventListener('load', function onLoad() {
    iframe.removeEventListener('load', onLoad);
    afterLoadAnimation();
    iframe.contentWindow.postMessage(
      { type: SET_WIDGET_VIEW, isFullScreen: isFullScreen() },
      iframeSrc
    );
    window.onmessage = message => {
      if (message.data == WIDGET_HIDE) onHide();
      if (message.data == WIDGET_CLOSE) onClose();
    };
  });

  return iframe;
};

const buildQueryParams = ({ settings = {}, data = {} }) => {
  const params = ['isWidget=true'];
  const { header = {}, bot = {}, menu = {}, userMessage = {}, wordSuggestions = {} } = settings;
  [
    ['referrer', window.location.origin],
    ['logoUrl', header.logoUrl],
    ['logoText', header.logoText],
    ['buttonColor', header.buttonColor],
    ['avatarUrl', bot.avatarUrl],
    ['key', data.key],
    ['locale', data.locale],
    ['userMessageColor', userMessage.color],
    ['userMessageBackgroundColor', userMessage.backgroundColor],
    ['menuColor', menu.color],
    ['menuBackgroundColor', menu.backgroundColor],
    ['menuItemBackgroundColor', menu.itemBackgroundColor],
    ['wordSuggestionsColor', wordSuggestions.color],
    ['wordSuggestionsBackgroundColor', wordSuggestions.backgroundColor],
  ].forEach(([key, val]) => {
    // val can be an empty string to mute the logoText
    if (val !== undefined) params.push(`${key}=${encodeURIComponent(val)}`);
  });

  return params;
};

const WebChat = webchatParams => {
  const style = Object.assign({}, defaultStyle, fullSpace);
  const updatedParams = Object.assign({}, webchatParams, {
    params: buildQueryParams(webchatParams),
  });
  // main container
  const div = Div({ style });
  div.appendChild(buildFrame(updatedParams));
  return div;
};

export default WebChat;
